import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import Slider from 'react-slick';
import { graphql, StaticQuery } from 'gatsby';

import ReviewCard from './ReviewCard';

import Link from '/src/components/LocalizedLink';
import IconArrowRight from '../assets/images/svg/arrow-right-slider.inline.svg';
import IconArrowRightMoreReviews from '../assets/images/svg/arrow-right-red.inline.svg';

const ReviewsSection = ({ hideAllReviews = false, description = null, title }) => {
  const intl = useIntl();

  const reviewsTitle = title && intl.formatMessage(title);
  const reviewsDescription = description !== null ? intl.formatMessage(description) : description;

  return (
    <StaticQuery
      query={graphql`
        query {
          allPrismicTestimonials(sort: { order: DESC, fields: last_publication_date }) {
            edges {
              node {
                id
                data {
                  title {
                    text
                  }
                  quote {
                    text
                  }
                  user_avatar {
                    url
                  }
                  user_name {
                    text
                  }
                  user_description {
                    text
                  }
                }
              }
            }
          }
        }
      `}
      render={(data) => {
        const allPrismicTestimonials = data.allPrismicTestimonials.edges;

        const PrevArrow = (props) => {
          const { onClick } = props;
          return (
            <div onClick={onClick} className="slider-arrow slider-arrow--prev">
              <IconArrowRight />
            </div>
          );
        };
        const NextArrow = (props) => {
          const { onClick } = props;
          return (
            <div onClick={onClick} className="slider-arrow slider-arrow--next">
              <IconArrowRight />
            </div>
          );
        };

        const settings = {
          infinite: true,
          slidesToShow: 3,
          //  fade: true,
          autoplaySpeed: 5000,
          // centerMode: true,
          speed: 500,
          nextArrow: <NextArrow />,
          prevArrow: <PrevArrow />,
          responsive: [
            {
              breakpoint: 1279,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 1023,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        };

        return (
          <>
            <Helmet>
              <link
                rel="stylesheet"
                type="text/css"
                charset="UTF-8"
                href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
              />
              <link
                rel="stylesheet"
                type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
              />
            </Helmet>
            <div className="c-reviews container">
              <h2 className="c-title-34">{reviewsTitle}</h2>
              {reviewsDescription && <p className="c-text-18">{reviewsDescription}</p>}
              <Slider {...settings}>
                {allPrismicTestimonials.map(({ node }) => (
                  <div key={node.id}>
                    <ReviewCard data={node.data} />
                  </div>
                ))}
              </Slider>
              {!hideAllReviews && (
                <FormattedMessage id="url.about.graduates">
                  {(locale) => (
                    <Link
                      to={locale[0]}
                      className="c-btn c-btn--white c-title-16 link-more-reviews"
                    >
                      <FormattedMessage id="graduates.seeAllReviews" />
                      <IconArrowRightMoreReviews />
                    </Link>
                  )}
                </FormattedMessage>
              )}
            </div>
          </>
        );
      }}
    />
  );
};

export default ReviewsSection;
